import { UseFormReturnType } from "@mantine/form";
import Input from "@/components/Input";
import { useTranslation } from "@/i18n/client";
import Select from "@/components/Select";
import { Address, AddressType } from "@/types/address";
import { AddressFormValues } from "./form";
import { useContext, useMemo } from "react";
import { EnumerationsContext } from "@/contexts/EnumerationsContext";
import { GeneralEnumeration } from "@/types/enumerations";

export const getMappedCountriesToSelect = (generalEnum: GeneralEnumeration[]) =>
  generalEnum.map(item => ({
    value: item.value,
    label: item.name,
  }));

const inputs = ["street", "houseNumber", "streetNumber", "city", "cityPart", "zip"] as const;

const ForeignAddress = ({ form, addressType }: { form: UseFormReturnType<AddressFormValues>; addressType: AddressType }) => {
  const enums = useContext(EnumerationsContext);
  const { t } = useTranslation("address");

  const setAddressKey = (key: keyof Address, value: string) => {
    form.setFieldValue(`${addressType}.${key}`, value);
  };

  const mappedCountries = useMemo(
    () => getMappedCountriesToSelect(enums.countries.filter(country => country.value !== "CZ")),
    [enums.countries]
  );

  return (
    <>
      <Select
        searchable
        label={t("country")}
        data={mappedCountries}
        withRightSection={false}
        {...form.getInputProps(`${addressType}.countryCode`)}
        onChange={value => {
          if (value !== null) {
            setAddressKey("countryCode", value);
          }
        }}
      />
      {inputs.map(input => (
        <Input
          key={input}
          label={t(input)}
          {...form.getInputProps(`${addressType}.${input}`)}
          onChange={event => setAddressKey(input, event.target.value)}
          pii
        />
      ))}
    </>
  );
};

export default ForeignAddress;
